module.exports = __webpack_public_path__ + "static/media/barion.2069ff7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/barion.jpg
// module id = 227
// module chunks = 0